export default class GetCategoriaByTipoCursoAndId {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idTipoCurso, idCategoria) {
    try {
      const result = await this.#repository.getCategoriaByTipoCursoAndId(idTipoCurso, idCategoria)
      return result
    } catch (error) {
      throw error
    }
  }
}
